<script>
import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 20,
        breakpoints: {
          1024: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 20
          }
        },
        pagination: {
          el: '.swiper-pagination'
        },

      }
    }
  },
}
</script>

<template>
  <div class="pulmonology">
    <!--    <section class="section section1">-->
    <!--      <h2>Пульмонологія </h2>-->

    <!--      <img class="mob" src="@/assets/img/bronchialAsthma/banner-mob.png" alt="banner">-->
    <!--    </section>-->

    <div class="pulmonology__banner">
      <div class="pulmonology__wrapper container">
        <div class="left">
          <h1 class="pulmonology__banner--title">Пульмонологія</h1>
        </div>
        <div class="right">
          <img class="img-desc" src="@/assets/img/bronchialAsthma/banner.svg">
          <img class="img-mob" src="@/assets/img/bronchialAsthma/banner-mob.svg">
        </div>
      </div>
    </div>

    <section class="section section2">
      <div class="container">
        <div class="section2__col section2__col--first">
          <h3>Дія програми підтримки пацієнтів «ТерапіяПЛЮС»<br><span>поширюється на:</span>
          </h3>
          <div class="section2__iconText">
            <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_60_882)">
                <circle cx="48" cy="48" r="47.5" stroke="#3C1053"/>
              </g>
              <circle cx="48" cy="48" r="42.5" fill="#FFD770" stroke="#3C1053"/>
              <path
                  d="M50.2149 67.3312L24.5365 45.457C24.2148 45.1829 24.1001 44.7362 24.2499 44.3411L28.9727 31.8903C29.2246 31.2263 30.0689 31.0291 30.5888 31.5128L50.3174 49.8651C50.7019 50.2227 51.2975 50.2221 51.6812 49.8636L87.3173 16.572C87.9564 15.9749 89 16.4281 89 17.3027V20.1492C89 20.3763 88.9227 20.5966 88.7809 20.7739L51.6443 67.1947C51.2917 67.6354 50.6445 67.6972 50.2149 67.3312Z"
                  fill="white" stroke="#3C1053"/>
              <defs>
                <clipPath id="clip0_60_882">
                  <rect width="48" height="96" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <p class="section2__text1">
              інноваційний* лікарський засіб компанії «АстраЗенека»
              для лікування тяжкої бронхіальної астми
            </p>
          </div>
          <p class="section2__text2"><b>Оригінальний (інноваційний) лікарський засіб - </b>
            <i>
              лікарський засіб, зареєстрований уперше в світі на основі повного реєстраційного досьє щодо його
              ефективності, безпеки та якості. (Закон України «Про лікарські засоби» №2469-ІХ, чинний станом на травень
              2026 року)
            </i>
          </p>
        </div>
        <div class="section2__col section2__col--second">
          <img src="@/assets/img/bronchialAsthma/section2-img1.png" alt="img">
        </div>

        <div class="section2__decor">
          <img class="section2__decor-item section2__decor-item--item1"
               src="@/assets/img/bronchialAsthma/section2-patern.svg" alt="pattern">
          <img class="section2__decor-item section2__decor-item--item2"
               src="@/assets/img/bronchialAsthma/section2-patern.svg" alt="pattern">
          <img class="section2__decor-item section2__decor-item--item3"
               src="@/assets/img/bronchialAsthma/section2-patern.svg" alt="pattern">
          <img class="section2__decor-item section2__decor-item--item4"
               src="@/assets/img/bronchialAsthma/section2-patern.svg" alt="pattern">
          <img class="section2__decor-item section2__decor-item--item5"
               src="@/assets/img/bronchialAsthma/section2-patern.svg" alt="pattern">
        </div>
      </div>
    </section>

    <section class="section section3">
      <div class="section3__content container">
        <div class="section3__col section3__col--first">
          <h3>
            Астма є глобальною проблемою охорони здоров’я. Від цього серйозного захворювання страждає близько 300
            мільйонів людей у всьому світі. Воно&nbsp;спричиняє приблизно 1&nbsp;000&nbsp;смертей щодня.
          </h3>
          <p>
            Астма заважає людям працювати, навчатися, жити щасливим життям. Особливо важко, коли на астму хворіють
            діти<sup>1</sup>.
            Проте, більшості смертей можна запобігти, а саме захворювання можна і потрібно взяти під
            контроль<sup>1</sup>.
            <br>
            <b>Астма — </b>
            це захворювання дихальних шляхів, яке зазвичай є хронічним і супроводжується запаленням в дихальних
            шляхах<sup>1</sup>.
            <br>
            <b>У більшості випадків астма пов’язана із запаленням дихальних шляхів та надмірною реакцією організму на
              подразники<sup>1</sup>.</b>
          </p>
        </div>
        <div class="section3__col section3__col--second">
          <img src="@/assets/img/bronchialAsthma/section3-img1.png" alt="img">
        </div>
      </div>
    </section>

    <section class="section section4">
      <div class="section4__content container">
        <div class="section4__col section4__col--first">
          <h3>Основою лікування для всіх пацієнтів з астмою, незалежно від&nbsp;її ступеня тяжкості, є інгаляційні кортикостероїди.</h3>
          <p><b>Біологічні лікарські засоби допомагають контролювати астму,</b> тому що вони <b>блокують речовини або
            клітини,</b> які
            спричиняють <b>набряк і запалення у дихальних шляхах</b> після контакту з певними чинниками (наприклад,
            пилком,
            алергенами чи інфекціями)<sup>2</sup>.</p>
        </div>
        <div class="section4__col section4__col--second">
          <img src="@/assets/img/bronchialAsthma/section4-img1.png" alt="img">
        </div>
      </div>
    </section>

    <section class="section section5">
      <div class="section5__row section5__row--desk container">
        <div class="section5__item">
          <img class="section5__item-img1" src="@/assets/img/bronchialAsthma/section5-item1.png" alt="">
          <p class="section5__item-num">I.</p>
          <p class="section5__item-text">
            Коли організм реагує на такі тригери, його захисна система утворює молекули, які призводять до запалення і
            появи симптомів астми<sup>3</sup>
          </p>
        </div>

        <div class="section5__item">
          <img class="section5__item-img2" src="@/assets/img/bronchialAsthma/section5-item3.png" alt="">
          <p class="section5__item-num">II.</p>
          <p class="section5__item-text">
            Біологічні препарати приєднуються до цих молекул і зупиняють запалення, допомагаючи зменшити симптоми астми
            та полегшити дихання<sup>3</sup>
          </p>
        </div>
      </div>

      <div class="container">
        <Swiper :options="swiperOption" class="mySwiper">
          <SwiperSlide class="section5__item slider1">
            <img class="section5__item-img1" src="@/assets/img/bronchialAsthma/section5-item1.svg" alt="">
            <p class="section5__item-num">I.</p>
            <p class="section5__item-text">Коли організм реагує на такі тригери, його захисна система утворює молекули,
              які призводять до запалення і
              появи симптомів астми<sup>3</sup></p>
          </SwiperSlide>
          <SwiperSlide class="section5__item slider1">
            <img class="section5__item-img2" src="@/assets/img/bronchialAsthma/section5-item2.svg" alt="">
            <p class="section5__item-num">II.</p>
            <p class="section5__item-text">Біологічні препарати приєднуються до цих молекул і зупиняють запалення,
              допомагаючи зменшити симптоми астми
              та полегшити дихання<sup>3</sup></p>
          </SwiperSlide>
          <div class="swiper-pagination" slot="pagination"></div>
        </Swiper>
      </div>
    </section>

    <section class="section section6">
      <div class="section6__row section6__row--first">
        <div class="container">

          <h2>Учасник програми, якому лікар призначив відповідний препарат, може придбати його зі&nbsp;знижкою за
            карткою учасника програми*</h2>
        </div>
      </div>
      <div class="section6__row section6__row--second ">
        <div class="container">
          <div class="section6__table section6__table--desk">

            <table>
              <tr>
                <td class="section6__item-head section6__item-head--first">Діюча речовина</td>
                <td class="section6__item-head">Дозування</td>
                <td class="section6__item-head section6__item-head--last">Розмір знижки для учасників програми</td>
              </tr>

              <tr>
                <td class="section6__item-body section6__item-body--first">
              <span>
             Тезепелумаб
                </span>
                </td>
                <td class="section6__item-body section6__item-body--second">
                  <span>
                    1 попередньо наповнена шприц-ручка містить<br><span class="color">210 мг</span> тезепелумабу в <span
                      class="color">1,91 мл</span> розчину
                  </span>
                </td>
                <td class="section6__item-body section6__item-body--last">
              <span>
              <span class="big">-60 <span>% </span></span>
              </span></td>
              </tr>
            </table>

          </div>

          <div class="section6__table section6__table--mob">

            <table>
              <tr>
                <td class="section6__item-head section6__item-head--first">Діюча речовина</td>
              </tr>

              <tr>
                <td class="section6__item-body">
              <span>
                Тезепелумаб
                </span>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td class="section6__item-head">Дозування</td>
              </tr>

              <tr>
                <td class="section6__item-body">
              <span>
                1 попередньо наповнена шприц-ручка&nbsp;містить<br><span class="color">210&nbsp;мг</span> тезепелумабу в&nbsp;<span
                  class="color">1,91&nbsp;мл</span> розчину
              </span>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td class="section6__item-head section6__item-head--last">Розмір знижки для учасників програми</td>
              </tr>

              <tr>
                <td class="section6__item-body section6__item-body--last">
              <span>
              <span class="big">-60 <span>% </span></span>
              </span></td>
              </tr>
            </table>

          </div>

          <p class="section6__smallText">
            Література: 1. Адаптовано з : Global Strategy for Asthma Management and Prevention, Global Initiative for
            Asthma
            (GINA) 2025. http://www.ginasthma.org/(Останній захід 04.05.2026); 2. McGregor, M. C., Krings, J. G., Nair,
            P., & Castro, M. (2019). Role of biologics in asthma. American Journal of Respiratory and Critical Care
            Medicine, 199(4), 433–445. https://doi.org/10.1164/rccm.201810-1944ci; 3. Busse, W. W. (2019). Biological
            treatments for severe asthma: A major advance in asthma care. Allergology International, 68(2).
            https://doi.org/10.1016/j.alit.2019.01.004.
          </p>
        </div>
      </div>
    </section>

    <section class="section section7">
      <div class="content container">
        <a href="/Terapiaplus_Bronchial_Asthma_Content_01.pdf" download class="section7__download">
          <p>Завантажити матеріали </p>
        </a>

        <div class="section7__videoWrapper">
          <video
              controls
              controlsList="nodownload"
              width="100%"
              height="100%"
              style="position: absolute; top: 0; left: 0; z-index: 20;"
              :poster="require('@/assets/img/bronchialAsthma/video-image.png')"

          >
            <source src="/video/howToUse.webm" type="video/webm">
            Ваш браузер не підтримує відтворення відео.
          </video>
          <div class="overlay"></div>
        </div>


        <p class="section7__description">Заборонено будь-яке завантаження, копіювання чи використання голосу,
          аудіодоріжки цього відео або його
          фрагментів для будь-якого використання, а також імітації голосу, створення синтетичних голосових відтворень
          та/або навчання моделей штучного інтелекту
        </p>
      </div>

    </section>
  </div>
</template>

<style scoped lang="scss">
.pulmonology {

  &__banner {
    overflow: hidden;
    position: relative;
    height: 396px;
    // padding: 88px 0 308px;
    background: #69b6c7 url("~@/assets/img/bronchialAsthma/patternt.png") no-repeat center calc(100% - 131px);
    background-size: contain;
    background-position-y: bottom;
    z-index: 1;
    @media (max-width: 1024px) {
      background: #69b6c7;
      height: auto;
    }
    //@media (max-width: 768px) {
    //  background-size: unset;
    //}


    &--title {
      font-size: 72px;
      line-height: 80px;
      font-weight: 700;
      color: #fff;
      margin-top: 115px;
      @media (max-width: 1200px) {
        font-size: 56px;
        line-height: 64px;
        margin-top: 40px;
      }
      @media screen and (max-width: 1336px) {
      }
      @media screen and (max-width: 1024px) {

      }
      @media (max-width: 768px) {
        font-size: 48px;
        line-height: 40px;
        padding-left: 20px;
      }
      @media (max-width: 550px) {
        font-size: 32px;

      }

    }
  }

  &__wrapper {
    display: flex;
    justify-content: space-between;
    height: 100%;
    position: relative;
    //padding-left: 0;
    //padding-right: 0;

    @media (max-width: 1024px) {
      flex-direction: column;
    }
    @media (max-width: 768px) {
      padding-left: 0;
      padding-right: 0;
    }
    @media (max-width: 400px) {
      padding: 0;
    }

    .right {
      position: absolute;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: flex-end;


      @media (max-width: 1770px) {
        right: -70px;
      }

      @media (max-width: 1024px) {
        right: 0;
      }

      @media (max-width: 1024px) {
        position: relative;
        right: 0;
      }

      .img-desc {
        width: 100%;
        height: auto;

        @media (max-width: 1770px) {
          max-width: 80%;
        }
        @media (max-width: 768px) {
          display: none;
        }
      }

      .img-mob {
        display: none;
        width: 100%;
        height: auto;
        @media (max-width: 768px) {
          display: block;
        }
      }
    }
  }

  .section2 {
    width: 100%;
    margin: 0 auto;
    overflow: hidden;

    .container {
      padding: 100px 15px 92px 15px;

      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      z-index: 1;


      @media screen and (max-width: 1440px) {
        padding: 80px 15px 92px 15px;

      }

      @media screen and (max-width: 1200px) {
        padding: 40px 15px 92px 15px;
      }

      @media screen and (max-width: 1024px) {
        padding: 40px 20px 48px 20px;
        flex-direction: column;
      }
    }

    &__col {

      &--first {
        max-width: 773px;
        width: 100%;
        margin-right: 70px;

        @media (max-width: 1770px) {
          min-width: 773px;
          margin-right: 35px;
        }

        @media (max-width: 1440px) {
          min-width: 598px;
        }

        @media screen and (max-width: 1200px) {
          min-width: 441px;
        }

        @media screen and (max-width: 1024px) {
          max-width: 100%;
          min-width: 0;
          margin-right: 0;
        }
      }

      &--second {
        max-width: 536px;
        width: 100%;
        margin-right: 211px;

        @media screen and (max-width: 1770px) {
          margin-right: 80px;
        }

        @media (max-width: 1440px) {
          margin-right: 60px;
        }

        @media screen and (max-width: 1200px) {
        }

        @media screen and (max-width: 1024px) {
          max-width: 480px;
          margin: 40px auto 0 auto;
        }

        img {
          width: 100%;
          height: auto;
          display: block;

          @media screen and (max-width: 1024px) {
            padding: 0 40px;
          }
        }
      }
    }

    h3 {
      color: var(--Purple, #3C1053);

      font-size: 48px;
      font-style: normal;
      font-weight: 700;
      line-height: 64px;

      @media (max-width: 1440px) {
        font-size: 38px;
        line-height: 120%;
      }

      @media screen and (max-width: 1200px) {
        font-size: 28px;
        line-height: 120%;
      }

      @media screen and (max-width: 1024px) {
        font-size: 32px;
        line-height: 40px;
        //br {
        //  display: none;
        //}
      }

      span {
        color: #69B6C7;

        font-size: 48px;
        font-style: normal;
        font-weight: 700;
        line-height: 36px;

        @media (max-width: 1440px) {
          font-size: 38px;
          line-height: 120%;
        }

        @media screen and (max-width: 1200px) {
          font-size: 28px;
          line-height: 120%;
        }

        @media screen and (max-width: 1024px) {
          font-size: 32px;
          line-height: 40px;
          margin-bottom: 24px;
        }

      }
    }

    &__iconText {
      display: flex;
      align-items: center;
      margin-top: 56px;
      @media screen and (max-width: 1024px) {
        margin-top: 24px;
        flex-direction: column;
        align-items: flex-start;
      }

      > svg {
        margin-right: 50px;
        width: 96px;
        min-width: 96px;
        height: auto;
        display: block;

        @media (max-width: 1400px) {
          margin-right: 25px;
        }


        @media screen and (max-width: 1024px) {
          margin-right: 0;
          margin-bottom: 8px;

          width: 68px;
          min-width: 68px;
        }
      }
    }

    &__text1 {
      max-width: 380px;
      width: 100%;
      color: var(--Purple, #3C1053);
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 36px;


      @media (max-width: 1200px) {
        font-size: 20px;
      }

      @media screen and (max-width: 1024px) {
        line-height: 32px;
        font-size: 20px;
        max-width: 320px;
      }

      svg {
        line-height: 0;
        width: 140px;
        height: auto;
        display: inline-block;
        margin-top: -7px;
      }
    }

    &__text2 {
      max-width: 613px;
      margin-top: 44px;
      color: var(--Purple, #3C1053);

      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 150% */

      @media screen and (max-width: 1024px) {
        margin-top: 24px;
        max-width: 100%;
      }

      b {
        font-weight: 600;
        color: var(--Purple, #3C1053);

      }

      i {
        color: var(--Purple, #3C1053);
        font-weight: 400;
        font-style: italic;
      }
    }

    &__decor {
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
      pointer-events: none;

      @media screen and (max-width: 1024px) {
        display: none;
      }

      &-item {
        width: 163px;
        height: auto;
        display: block;
        position: absolute;

        @media screen and (max-width: 1770px) {
          //width: 140px;
        }
        @media screen and (max-width: 1440px) {
          width: 130px;
        }
        @media screen and (max-width: 1200px) {
          width: 80px;
        }

        &--item1 {
          top: 47%;
          transform: translateY(-50%);
          left: -135px;

          @media screen and (max-width: 1770px) {
            left: -120px;
            top: 46%;
          }
          @media screen and (max-width: 1440px) {
            left: -110px;
            top: 40.4%;
          }

          @media screen and (max-width: 1200px) {
            left: -60px;
            top: 28.4%;
          }
        }

        &--item2 {
          top: 41%;
          left: 49.3%;
          transform: translate(-50%, -50%);

          @media screen and (max-width: 1770px) {
            top: 44%;
            left: 54.9%;
          }

          @media screen and (max-width: 1440px) {
            top: 41%;
            left: 51.1%;
          }

          @media screen and (max-width: 1200px) {
            top: 39%;
            left: 47.5%;
          }
        }

        &--item3 {
          top: 62%;
          left: 41.7%;
          transform: translate(-50%, -50%);
          @media screen and (max-width: 1770px) {
            top: 65%;
            left: 45.5%;
          }
          @media screen and (max-width: 1440px) {
            top: 60%;
            left: 45.2%;
          }
          @media screen and (max-width: 1200px) {
            top: 52%;
            left: 43%;
          }
        }

        &--item4 {

          top: 72.3%;
          left: 53.9%;
          transform: translate(-50%, -50%);

          @media screen and (max-width: 1770px) {
            top: 75.1%;
            left: 60.9%;
          }
          @media screen and (max-width: 1440px) {
            top: 69.3%;
            left: 59.9%;
          }
          @media screen and (max-width: 1200px) {
            top: 58.2%;
            left: 53.9%;
          }
        }

        &--item5 {
          right: -120px;
          bottom: 92px;
        }
      }
    }
  }

  .section3 {
    background: rgba(105, 182, 199, 0.1);

    &__content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      margin: 0 auto;
      padding: 150px 15px 0 15px;

      @media screen and (max-width: 1024px) {
        padding: 48px 20px 48px 20px;
        flex-direction: column;
      }

    }

    &__col {

      &--first {
        max-width: 911px;
        width: 100%;
        margin-right: 70px;

        @media (max-width: 1440px) {
          margin-right: 80px;
        }
        @media screen and (max-width: 1200px) {
          margin-right: 60px;
        }

        @media screen and (max-width: 1200px) {
          margin-right: 60px;
        }

        @media screen and (max-width: 1024px) {
          margin-right: 0;
        }

        h3 {
          color: var(--Purple, #3C1053);

          font-size: 48px;
          font-style: normal;
          font-weight: 700;
          line-height: 64px;
          max-width: 920px;
          width: 100%;

          @media (max-width: 1440px) {
            font-size: 38px;
            line-height: 120%;
          }

          @media screen and (max-width: 1200px) {
            font-size: 28px;
            line-height: 120%;
          }

          @media screen and (max-width: 1024px) {
            max-width: 100%;
            font-size: 32px;
            line-height: 40px;
          }
        }

        p {
          margin-top: 70px;
          color: var(--Purple, #3C1053);
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 36px;
          margin-bottom: 0;

          @media (max-width: 1440px) {
            font-size: 20px;
            line-height: 140%;
            margin-top: 53px;
          }
          @media screen and (max-width: 1200px) {
            font-size: 18px;
            margin-top: 35px;
          }

          @media screen and (max-width: 1024px) {
            font-size: 18px;
            line-height: 28px;
            margin-top: 20px;
          }


          b {
            font-weight: 700;
            margin-top: 10px;
            display: inline-block;

          }
        }
      }

      &--second {
        max-width: 352px;
        width: 100%;
        margin-right: 208px;

        @media screen and (max-width: 1770px) {
          margin-right: 86px;
          max-width: 290px;
        }

        @media (max-width: 1440px) {
          max-width: 274px;
          margin-right: 69px;
        }

        @media screen and (max-width: 1200px) {
          max-width: 255px;
          margin-right: 66px;
        }

        @media screen and (max-width: 1024px) {
          margin-top: 40px;
          margin-right: 0;
          max-width: 320px;
          padding: 0 40px;
        }

        img {
          width: 100%;
          height: auto;
          display: block;

        }
      }
    }
  }

  .section4 {
    background: rgba(105, 182, 199, 0.1);

    &__content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      padding: 150px 15px 0 15px;

      @media screen and (max-width: 1024px) {
        padding: 48px 20px 48px 20px;
        flex-direction: column;
      }

      @media screen and (max-width: 768px) {
        padding: 48px 20px 96px 20px;
        flex-direction: column;
      }
    }

    &__col {

      &--first {
        max-width: 920px;
        width: 100%;
        margin-right: 120px;

        @media (max-width: 1440px) {
          margin-right: 80px;
        }

        @media screen and (max-width: 1200px) {
          margin-right: 60px;
        }

        @media screen and (max-width: 1024px) {
          margin-right: 0;
        }

        h3 {
          color: var(--Purple, #3C1053);

          font-size: 48px;
          font-style: normal;
          font-weight: 700;
          line-height: 64px;
          @media (max-width: 1440px) {
            font-size: 38px;
            line-height: 120%;
          }

          @media screen and (max-width: 1200px) {
            font-size: 28px;
            line-height: 120%;
          }

          @media screen and (max-width: 1024px) {
            font-size: 32px;
            line-height: 40px;
          }
        }

        p {
          margin-top: 45px;
          color: var(--Purple, #3C1053);
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 36px;
          margin-bottom: 0;

          max-width: 742px;
          width: 100%;

          @media (max-width: 1440px) {
            font-size: 20px;
            line-height: 140%;
          }
          @media screen and (max-width: 1200px) {
            font-size: 18px;
            margin-top: 35px;
          }

          @media screen and (max-width: 1024px) {
            max-width: 100%;
            font-size: 18px;
            line-height: 28px;
            margin-top: 20px;
          }

          b {
            font-weight: 700;

            &.desk {
              @media screen and (max-width: 1024px) {
                display: none;
              }
            }
          }
        }
      }

      &--second {
        max-width: 428px;
        width: 100%;
        margin-right: 181px;

        @media screen and (max-width: 1770px) {
          margin-right: 63px;
          max-width: 357px;
        }

        @media (max-width: 1440px) {
          max-width: 332px;
          margin-right: 47px;
        }

        @media screen and (max-width: 1200px) {
          margin-right: 47px;
          max-width: 310px;
        }

        @media screen and (max-width: 1024px) {
          max-width: 300px;
          margin-top: 40px;
          margin-right: 0;
        }

        @media screen and (max-width: 768px) {
          padding: 0 40px 0 5px;
        }

        img {
          width: 100%;
          height: auto;
          display: block;

        }
      }
    }
  }

  .section5 {
    background: rgba(105, 182, 199, 0.1);

    &__row {

      max-width: 1920px;
      padding: 150px 15px 150px 15px;

      display: grid;

      grid-gap: 160px;

      grid-template-columns: 1fr 1fr;
      @media screen and (max-width: 1700px) {
        grid-gap: 140px;
      }
      @media screen and (max-width: 1445px) {
        grid-gap: 100px;
      }
      @media screen and (max-width: 1350px) {
        grid-gap: 60px;
      }

      &--desk {
        @media screen and (max-width: 768px) {
          display: none;
        }
      }
    }

    &__item {

      display: flex;
      flex-direction: column;

      &-num {
        color: #70C2D4;

        font-size: 72px;
        font-style: normal;
        font-weight: 700;
        line-height: 88px; /* 122.222% */

        margin-top: -88px;
        margin-bottom: 8px;

        @media (max-width: 1440px) {
          font-size: 62px;
        }
        @media screen and (max-width: 1200px) {
          font-size: 58px;
        }
        @media screen and (max-width: 1024px) {
          font-size: 52px;
        }
      }

      &-text {
        color: var(--Purple, #3C1053);

        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 36px;

        @media (max-width: 1440px) {
          font-size: 22px;
          line-height: 140%;
        }
        @media screen and (max-width: 1200px) {
          font-size: 20px;
        }

        @media screen and (max-width: 1024px) {
          font-size: 20px;
          line-height: 28px; /* 140% */
        }
      }

      img {
        max-width: 320px;
        width: 100%;
        height: auto;

        display: block;

        @media screen and (max-width: 1440px) {
          max-width: 50%;
        }

        @media screen and (max-width: 1024px) {
          max-width: 176px;
        }
        @media screen and (max-width: 768px) {
          position: relative;
          left: 50%;
          transform: translateX(-50%);
        }
      }

      &-img1 {
        transform: translate(75px, -20px);

        @media screen and (max-width: 1440px) {
          max-width: 40%;
        }

        @media screen and (max-width: 1024px) {
          transform: translate(75px, 0);
          padding-bottom: 15px;
        }

        @media screen and (max-width: 768px) {
          max-width: 230px !important;
          padding-bottom: 5px;
        }
      }

      &-img2 {
        transform: translate(75px, -20px);
        max-width: 281px !important;

        @media screen and (max-width: 1440px) {
          max-width: 44% !important;
        }
        @media screen and (max-width: 1024px) {
          transform: translate(75px, 0);
          padding-bottom: 5px;
          max-width: 37.6% !important;
        }

        @media screen and (max-width: 991px) {
          max-width: 49.9% !important;
        }
        @media screen and (max-width: 768px) {
          max-width: 167px !important;
        }
      }

    }

    .mySwiper {
      display: none;
      //max-width: 480px;
      margin: 0 auto;
      //padding-bottom: 40px;
      padding: 0 0 80px 0;
      @media screen and (max-width: 768px) {
        display: block;
      }

      ::v-deep(.swiper-pagination-bullet) {
        border: 1px solid #63B3CD;
        background: white;
        opacity: 1;
        bottom: 48px;

        &.swiper-pagination-bullet-active {
          background: #63B3CD;
          width: 8px;
          height: 8px;
        }
      }
    }

    &__title {
      color: var(--Purple, #3C1053);

      font-size: 32px;
      font-weight: 700;
      line-height: 40px;
      margin-bottom: 32px;

      &--mobile {

        display: none;
        @media screen and (max-width: 1024px) {
          display: block;
        }
      }
    }
  }

  .section6 {

    &__row {

      &--first {
        padding: 150px 0 220px 0;

        background: url("~@/assets/img/bronchialAsthma/section6-bg.png") #FFEEC3 repeat-x left top;
        background-size: contain;


        @media screen and (max-width: 1024px) {
          margin-right: 0;
          padding: 48px 20px 100px 20px;

          background: url("~@/assets/img/bronchialAsthma/section6-bg.png") #FFEEC3 repeat-x left top;
          background-size: cover;
        }

        .container {
          padding-left: 0;
          padding-right: 0;
        }

        h2 {
          color: var(--Purple, #3C1053);
          text-align: center;
          width: 75%;
          margin: 0 auto;

          font-size: 48px;
          font-style: normal;
          font-weight: 700;
          line-height: 64px;
          @media (max-width: 1440px) {
            width: 100%;
            font-size: 42px;
            line-height: 52px;
          }

          @media screen and (max-width: 1024px) {
            font-size: 32px;
            width: 100%;
            line-height: 40px; /* 125% */
            text-align: left;
          }
        }
      }

      &--second {
        background: #69B6C7;
        padding: 0 0 220px 0;


        @media screen and (max-width: 1024px) {
          padding: 0 20px 48px 20px;
        }

        .container {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }

    &__table {
      width: 100%;
      margin: 0 auto 0 auto;
      top: -120px;
      position: relative;

      @media screen and (max-width: 1024px) {
        top: -60px;
      }

      &--mob {
        display: none;
        @media screen and (max-width: 1024px) {
          display: block;
        }
      }

      &--desk {
        @media screen and (max-width: 1024px) {
          display: none;
        }
      }

      table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        border: 1px dashed #FFF;

        @media screen and (max-width: 1024px) {
          margin-bottom: 12px;
        }

        td {
          width: calc(100% / 3);
          @media screen and (max-width: 1024px) {
            width: 100%;

          }
        }
      }
    }

    &__item {
      //height: fit-content;

      &-head {
        color: #FFF;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 36px;

        //border-top: 1px dashed #FFF;
        border-left: 1px dashed #FFF;
        background: #69B6C7;
        margin-bottom: 0;
        padding: 32px 20px;
        text-align: center;

        &--first {
          border-left: none;
        }

        @media screen and (max-width: 1024px) {
          line-height: 120%;
          font-size: 16px;

          padding: 10px 20px;
          //border-top: 1px dashed #FFF;
          //border-left: 1px dashed #FFF;
          //border-right: 1px dashed #FFF;
        }

        &--last {
          //border-right: 1px dashed #FFF;
        }
      }

      &-body {
        border-top: 1px dashed #69B6C7;
        border-left: 1px dashed #69B6C7;
        //border-bottom: 1px dashed #69B6C7;
        background: var(--White, #FFF);

        padding: 70px 20px;
        height: 100%;
        text-align: center;

        @media screen and (max-width: 1024px) {
          border-left: none;
          padding: 35px 20px;
        }

        > span {
          color: var(--Purple, #3C1053);
          font-size: 34px;
          font-style: normal;
          font-weight: 400;
          line-height: 36px; /* 105.882% */

          .color {
            color: #69B6C7;
          }

          @media screen and (max-width: 1200px) {
            font-size: 28px;
          }

          @media screen and (max-width: 1024px) {
            font-size: 24px;
            line-height: 36px;
          }
        }

        &--second {
          padding: 70px 100px;
          @media screen and (max-width: 1770px) {
            padding: 70px 50px;
          }
          @media screen and (max-width: 1440px) {
            padding: 70px 10px;
          }
        }

        &--last {
          //border-right: 1px dashed #69B6C7;
        }

        &--first {
          border-left: none;
        }

        .big {
          color: #69B6C7;
          font-size: 58px;
          font-style: normal;
          font-weight: 700;
          line-height: 64px;

          > span {
            color: #69B6C7;
            font-size: 42px;
            font-style: normal;
            font-weight: 700;
            line-height: 40px;

          }
        }
      }

    }

    &__smallText {
      max-width: 1680px;
      width: 100%;
      margin: -80px auto 0 auto;

      color: #FFF;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;

      @media screen and (max-width: 1024px) {
        margin: -40px auto 0 auto;
        font-size: 14px;
      }

      svg {
        width: 8px;
        height: auto;
        display: inline-block;
        position: relative;
        top: -2px;
        margin-right: 8px;

        &:first-child {
          margin-right: 0;
        }
      }
    }
  }

  .section7 {

    background: rgba(105, 182, 199, 0.1);

    &__description {
      margin-top: 44px;
      color: #3C1053;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: 120%;

      @media screen and (max-width: 991px) {
        font-size: 14px;
      }
    }

    .content {

      padding: 100px 0 150px 0;

      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      @media screen and (max-width: 1024px) {
        padding: 60px 20px 48px 20px;
      }

    }

    a {
      display: flex;
      align-items: center;
      justify-content: center;

      text-decoration: none;
      border-radius: 2px;
      border: 1px solid var(--Purple, #3C1053);
      background: #70C2D4;
      padding: 24px 44px;
      margin-bottom: 100px;
      text-align: center;
      @media screen and (min-width: 1024px) {
        &:hover {
          background: #C4D600;
        }
      }

      &:active {
        background: #C4D600;
      }

      @media screen and (max-width: 1024px) {
        margin-bottom: 60px;
      }

      p {
        color: var(--Purple, #3C1053);
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        letter-spacing: 1.26px;
        text-transform: uppercase;
        text-align: center;
        @media screen and (max-width: 1024px) {
          font-size: 14px;
          letter-spacing: 0.98px;
        }
      }
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
      pointer-events: none;
      z-index: 10;
    }

    &__videoWrapper {
      position: relative;
      padding-bottom: 56.25%; /* 16:9 */
      width: 100%;
      height: 0;
      overflow: hidden;


      iframe {
        position: absolute;
        z-index: 20;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>